import { useHttpStatus } from 'hooks/';
import React, { useState } from 'react';
import { invalid } from 'constants/color';
import { useModal } from 'contexts/Modal';
import {
  StyledBody,
  StyledFooter,
  StyledDashLine,
} from 'components/Confirm/Confirm.styled';
import { CheckBox } from 'components/Inputs/';
import { CancelButton, RoundButton } from 'components/Buttons/';

/**
 * @param {{
 * confirm: Function
 * onClose: Function
 * }} param
 */
function Confirm({ confirm, onClose, checkCaption }) {
  const {
    onCancel,
    onConfirm,
    type = '',
    caption = '',
    options = { deleting: false },
  } = confirm || {};
  let component = null;
  const isDeleting = options?.deleting || false;
  const buttonText = isDeleting ? 'Delete' : 'Confirm';
  const { deleteInvoice, setDeleteInvoice } = useModal();
  const [isSubmitting, setIsSubmitting] = useState(false);
  if (checkCaption) {
    component = (
      <span style={{ marginLeft: '10px' }}>
        <CheckBox
          caption={checkCaption}
          isChecked={deleteInvoice}
          inputId="confirm-modal-checkbox"
          onChange={() => setDeleteInvoice((prev) => !prev)}
        />
      </span>
    );
  }

  useHttpStatus({
    status: 'ALL',
    actions: [type],
    resetCallBack: true,
    callBack: setIsSubmitting,
  });

  function onConfirmClick() {
    setIsSubmitting(true);
    if (onConfirm) {
      onConfirm();
    }
  }

  function onCloseClick() {
    onClose();
    if (onCancel) {
      onCancel();
    }
  }

  return (
    <>
      <StyledBody>
        {caption} {component}
      </StyledBody>
      <StyledDashLine />
      <StyledFooter>
        <CancelButton flexWidth={30} caption="Cancel" onClick={onCloseClick} />
        <RoundButton
          flexWidth={30}
          backColor={invalid}
          caption={buttonText}
          onClick={onConfirmClick}
          isDisabled={isSubmitting}
        />
      </StyledFooter>
    </>
  );
}

export default Confirm;
